import { Box, Card, CardProps, Icon, Typography } from "@xcorejs/ui";
import NextIcon from "components/Icons/16/next.svg";
import styled from "styled-components";

export type CareerCardProps = {
  title?: string;
  subtitle?: string;
} & CardProps;

const CareerCardStyle = styled(Card)<CareerCardProps>`
  & p {
    transition: color 300ms;
  }

  & svg {
    transition: fill 300ms;
  }

  &:hover {
    background-color: #fff;
    box-shadow: 0 4.5rem 2.5rem -2.5rem rgba(94, 96, 98, 0.5);

    p {
      color: #1e1e1e;
    }

    svg path {
      fill: #e00437 !important;
    }
  }
`;

const CareerCard = ({ title, subtitle, ...props }: CareerCardProps) => {
  return (
    <CareerCardStyle
      variant="elevated"
      width="100%"
      maxWidth="100%"
      body={
        <Box width="100%" position="relative">
          <Typography
            variant="p"
            color="#fff"
            fontWeight={600}
            overflow="hidden"
            display="-webkit-box"
            WebkitLineClamp={2}
            WebkitBoxOrient="vertical"
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="p"
              color="lightGray"
              fontWeight={600}
              overflow="hidden"
              display="-webkit-box"
              WebkitLineClamp={2}
              WebkitBoxOrient="vertical"
              fontSize="1.3rem"
              lineHeight="1.4rem"
            >
              {subtitle}
            </Typography>
          )}
          <Icon svg={<NextIcon />} fill="#fff" position="absolute" bottom={0} right={0} />
        </Box>
      }
      _body={{
        padding: "3rem",
        height: "15rem",
      }}
      boxShadow="none"
      background="#5E6062"
      transition="background 300ms, box-shadow 300ms"
      {...props}
    />
  );
};

export default CareerCard;
